module.exports = __webpack_public_path__ + "media/assets/Preview-d95942316610ab26c58ae89bcb2fe7a8.svg";